import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ArrowIcon } from '../icons/icon';
import { IconComponent } from '../icons/icon-reusable';

@Component({
  selector: 'app-collapsible-side-panel',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './collapsible-side-panel.html',
})
export class CollapsibleSidePanelComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() icon = ArrowIcon;
  @Input() toggleSide: 'left' | 'right' = 'left';
  @Output() isOpenChange = new EventEmitter<boolean>();

  @HostBinding('style.position') readonly hostPosition = 'absolute';
  @HostBinding('style.top') readonly hostTop = '0';
  @HostBinding('style.right') readonly hostRight = '0';
  @HostBinding('style.bottom') readonly hostBottom = '0';
  @HostBinding('style.z-index') readonly hostZIndex = '20';
  @HostBinding('style.width') readonly hostWidth = '40%';
  @HostBinding('style.pointer-events') readonly hostPointerEvents = 'none';

  toggle(): void {
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
  }
}
